module.exports = __webpack_public_path__ + "static/media/icon-pill-badminton.efcb1ea7.svg";